import {
    CoachingEventStatus,
    CommitmentSummaryListItem,
    GoalModel,
} from '../../coaching-base/general';
import { MetricItem } from '../../coaching-tags/models/metric.coaching.model';
import { MetricData } from '../../insight/performance-data/metric.pd.model';
import { Column, Row } from '../experimental.grid';

import {
    CellContext,
    ColumnContext,
    ColumnID,
    compare,
    RowContext,
    TemplateID,
} from './kpi-set.observation.model';

export function makeColumns(): Array<Column<ColumnContext>> {
    const height = 35;

    return [
        {
            id: ColumnID.METRIC,
            width: 200,
            height,
            compareFn: compare,
            ctx: { templateId: TemplateID.HEADER },
        },
        {
            id: ColumnID.ACTUAL,
            width: 80,
            height,
            ctx: { templateId: TemplateID.HEADER },
        },
        {
            id: ColumnID.TARGET,
            width: 80,
            height,
            ctx: { templateId: TemplateID.HEADER },
        },
        {
            id: ColumnID.PCT_TARGET,
            width: 80,
            height,
            ctx: { templateId: TemplateID.HEADER },
        },
        {
            id: ColumnID.GOAL,
            width: 80,
            height,
            ctx: { templateId: TemplateID.HEADER },
        },
        {
            id: ColumnID.PCT_GOAL,
            width: 80,
            height,
            ctx: { templateId: TemplateID.HEADER },
        },
        {
            id: ColumnID.EXPIRY_DATE,
            width: 150,
            height,
            ctx: { templateId: TemplateID.HEADER },
        },
    ];
}

export function makeRows(
    behaviourId: number,
    subBehaviourId: number,
    metricIds: number[],
    metrics: MetricItem[],
    metricDataSet: MetricData[],
    commitmentSummary: CommitmentSummaryListItem[],
    metricId: number,
): Array<Row<RowContext, CellContext>> {
    const height = 35;

    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const metricData =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        metricDataSet && metricDataSet.length ? metricDataSet[0] : null;
    const assocCommitments = commitmentSummary
        ? commitmentSummary.filter(
              (c) =>
                  c.statusId === CoachingEventStatus.ACTIVE &&
                  metricId != null &&
                  c.goals?.some((g) => g.metricId === metricId) === true,
          )
        : null;

    // TODO revise. no way this is right
    const goalData = commitmentSummary
        ? commitmentSummary
              .filter((ee) => {
                  const hasFocusAndActive: boolean =
                      ee.behaviourId === behaviourId &&
                      (ee.subBehaviourId == null ||
                          ee.subBehaviourId === subBehaviourId) &&
                      ee.statusId === CoachingEventStatus.ACTIVE;

                  const isUnfocusedWithCoached =
                      behaviourId == null &&
                      assocCommitments.findIndex(
                          (x) => x.commitmentId === ee.commitmentId,
                      ) > -1;

                  return hasFocusAndActive || isUnfocusedWithCoached;
              })
              .reduce<GoalModel[]>((p, c) => {
                  c.goals && p.push(...c.goals);
                  return p;
              }, [])
        : null;

    return metricIds.map((e) => {
        const metric = metrics.find((ee) => ee.id === e);
        const mDat = metricData
            ? metricData.metrics.find((eee) => eee.id === e)
            : null;
        const gDat = goalData ? goalData.find((ee) => ee.metricId === e) : null;

        return {
            id: Math.random().toString(),
            height,
            ctx: { templateId: TemplateID.CONTENT },
            cells: [
                {
                    columnId: ColumnID.METRIC,
                    height,
                    ctx: { templateId: TemplateID.CONTENT, metric },
                },
                {
                    columnId: ColumnID.ACTUAL,
                    height,
                    ctx: { templateId: TemplateID.CONTENT, metricData: mDat },
                },
                {
                    columnId: ColumnID.TARGET,
                    height,
                    ctx: { templateId: TemplateID.CONTENT, metricData: mDat },
                },
                {
                    columnId: ColumnID.PCT_TARGET,
                    height,
                    ctx: { templateId: TemplateID.CONTENT, metricData: mDat },
                },
                {
                    columnId: ColumnID.GOAL,
                    height,
                    ctx: { templateId: TemplateID.CONTENT, goalData: gDat },
                },
                {
                    columnId: ColumnID.PCT_GOAL,
                    height,
                    ctx: { templateId: TemplateID.CONTENT, goalData: gDat },
                },
                {
                    columnId: ColumnID.EXPIRY_DATE,
                    height,
                    ctx: { templateId: TemplateID.CONTENT, goalData: gDat },
                },
            ],
        };
    });
}
